<template>
  <v-navigation-drawer
    v-model="isSelected"
    @transitionend="trans"
    class="message-drawer"
    absolute
    floating
    temporary
    right
    width="100%"
  >
    <v-toolbar
      class="message-toolbar"
      color="primary"
      absolute
      v-if="selectedMessage"
    >
      <v-progress-linear
        absolute
        bottom
        indeterminate
        color="accent"
        height="7"
        v-if="isGetSelectedMessagePending"
      ></v-progress-linear>
      <v-toolbar-title>
        {{ user.first_name }} {{ user.last_name }}
        <span class="subtitle-2" v-if="selectedMessage.message">{{
          asDate(selectedMessage.message.date)
        }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!readOnly" icon @click="toggleCompleted()" title="Completed">
        <v-icon :color="selectedMessage.completed ? 'accent' : ''"
          >mdi-check</v-icon
        >
      </v-btn>
      <v-btn v-if="!readOnly" icon @click="toggleStarred()" title="Star/Favourite">
        <v-icon :color="selectedMessage.starred ? 'accent' : ''"
          >mdi-star</v-icon
        >
      </v-btn>
      <v-btn
        icon
        @click="toggleMapMarker()"
        v-if="
          selectedMessage.location &&
          selectedMessage.action &&
          selectedMessage.action.properties.map &&
          !readOnly
        "
         :title="selectedMessage.properties.show_map_marker ? 'Hide Map Marker' : 'Show Map Marker'"
      >
        <v-icon>{{
          selectedMessage.properties.show_map_marker
            ? "mdi-map-marker"
            : "mdi-map-marker-off"
        }}</v-icon>
      </v-btn>
      <v-btn v-if="!readOnly" icon @click="remove()" title="Delete">
        <v-icon color>mdi-delete</v-icon>
      </v-btn>
      <v-btn icon color="dark" @click="close()" title="Close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container class="message-container px-0" v-if="selectedMessage">
      <!--<pre>{{selectedMessage}}</pre>-->
      <v-banner single-line v-if="selectedMessage.action">
        <!--<v-icon
          slot="icon"
          color="primary"
          size="36"
          v-if="
            !selectedMessage.action.properties ||
            !selectedMessage.action.properties.icon
          "
          >mdi-alert-circle-outline</v-icon
        >
        <div
          slot="icon"
          class="text-h5"
          v-if="
            selectedMessage.action.properties &&
            selectedMessage.action.properties.icon
          "
        >
          {{ selectedMessage.action.properties.icon }}
        </div>-->
        <div slot="icon">
          <v-avatar
            class="accent white--text"
          >
            <v-img :src="icon"></v-img>
          </v-avatar>
        </div>
        <div class="text-h5">
          {{ selectedMessage.action.name }}
          <span class="ml-2 body-2">{{
            selectedMessage.action.description
          }}</span>
        </div>
        <div v-if="selectedMessage.reference" class="body-2 text--secondary" title="Message reference">{{selectedMessage.reference}}</div>
        <template v-slot:actions>
          <div v-if="selectedMessage.completed !== true">
            <v-select
              v-model="selectedMessage.status"
              :items="statuses"
              label="Status"
              @change="setStatus()"
              :readonly="readOnly"
            ></v-select>
          </div>
        </template>
      </v-banner>
      <v-banner single-line v-if="selectedMessage.approved !== null">
        <v-icon
          slot="icon"
          :color="
            selectedMessage.approval_by_id
              ? selectedMessage.approved
                ? 'success'
                : 'error'
              : 'warning'
          "
          size="36"
          >{{ selectedMessage.approved ? "mdi-check" : "mdi-cancel" }}</v-icon
        >
        <div class="text-h5">
          <span v-if="selectedMessage.approval_by_id">{{
            selectedMessage.approved ? "Approved" : "Disapproved"
          }}</span>
          <span class="ml-2 body-2"
            >{{
              selectedMessage.approval_by_id ? "Required" : "Requires"
            }}
            Approval</span
          >
        </div>
      </v-banner>

      <v-tabs v-model="tab" background-color="grey darken-3" grow>
        <v-tab>Message</v-tab>
        <v-tab>Data</v-tab>
        <v-tab>Notes</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container fluid>
            <v-row>
              <v-col
                class="fill-height"
                col="12"
                :md="
                  selectedMessage.action &&
                  selectedMessage.action.trigger.type === 'command'
                    ? 12
                    : 6
                "
              >
                <v-list-item two-line v-if="selectedMessage.elaborated">
                  <v-list-item-icon>
                    <v-icon>mdi-plus-box-multiple</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="title mb-1"
                      >Elaborated Message</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >The message that was constructed from elaborator
                      prompts.</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-row class="pl-7" v-if="selectedMessage.elaborated">
                  <v-sheet
                    class="newlines elaborated-message pa-3 rounded-b-lg"
                    :color="
                      $vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'
                    "
                    :dark="$vuetify.theme.dark"
                    v-html="selectedMessage.elaborated"
                  ></v-sheet>
                </v-row>
                <v-row
                  v-if="selectedMessage.files && selectedMessage.files.length"
                >
                  <v-col
                    v-for="file in selectedMessage.files"
                    :key="file.id"
                    class="d-flex child-flex image-grid-block"
                    cols="4"
                  >
                    <v-icon class="image-magnify text--white"
                      >mdi-magnify-plus</v-icon
                    >
                    <v-img
                      :src="`${filesUrl}/${file.id}?access_token=${accessToken}`"
                      contain
                      @click="
                        magnifyImage = `${filesUrl}/${file.id}?access_token=${accessToken}`
                      "
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="accent"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-row>
                <ImageMagnify :image-src.sync="magnifyImage"></ImageMagnify>
              </v-col>
              <v-col
                col="12"
                :md="selectedMessage.elaborated ? 6 : 12"
                v-if="
                  selectedMessage.action &&
                  selectedMessage.action.trigger.type !== 'command' &&
                  selectedMessage.message.text
                "
              >
                <v-list-item two-line v-if="selectedMessage.message">
                  <v-list-item-icon>
                    <v-icon>mdi-message</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="title mb-1"
                      >Original Message</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >The message that triggered the
                      action.</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-row class="pl-7">
                  <v-sheet
                    class="newlines pa-3 rounded-lg"
                    :color="
                      $vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'
                    "
                    :dark="$vuetify.theme.dark"
                    v-html="selectedMessage.message.text"
                  ></v-sheet>
                </v-row>
              </v-col>
            </v-row>

            <v-row v-if="selectedMessage.location">
              <v-col class="d-flex flex-column align-start" col="12">
                <v-list-item two-line>
                  <v-list-item-icon>
                    <v-icon>mdi-map-marker</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="title mb-1"
                      >Location</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >The elaborator's location prompt
                      result.</v-list-item-subtitle
                    >
                    <v-btn
                      text
                      outlined
                      class="mt-4"
                      :href="`https://www.google.com/maps/place/${selectedMessage.location.latitude}+${selectedMessage.location.longitude}`"
                      target="_blank"
                    >
                      <v-icon left>mdi-map</v-icon>View Location
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>

        <v-tab-item>
          <Data :message="selectedMessage" :read-only="readOnly"></Data>
        </v-tab-item>

        <v-tab-item>
          <Notes :message="selectedMessage" :read-only="readOnly"></Notes>
        </v-tab-item>
      </v-tabs-items>
      <!--<pre>{{selectedMessage}}</pre>-->
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import moment from "moment";
import { makeGetMixin } from "feathers-vuex";
import { mapState, mapGetters } from "vuex";
import ImageMagnify from "../widget/ImageMagnify";
import Data from "./message/Data";
import Notes from "./message/Notes";

export default {
  data() {
    return {
      isOpen: false,
      magnifyImage: null,
      icon: '',
      tab: null,
      statuses: ["new", "priority", "in progress", "unassigned", "assigned"],
    };
  },
  mixins: [
    makeGetMixin({
      service: "messages",
      name: "selectedMessage",
      id: "messageId",
    }),
  ],
  created() {},
  mounted() {},
  computed: {
    ...mapGetters("config", ["botApiUrl"]),
    ...mapState("apiAuth", ["accessToken"]),
    filesUrl() {
      return new URL(
        process.env.VUE_APP_FILES_PATH,
        this.botApiUrl || process.env.VUE_APP_API_URL
      ).toString();
    },
    user() {
      return (
        (this.selectedMessage && this.selectedMessage.member) ||
        (this.selectedMessage.message && this.selectedMessage.message.from)
      );
    },
    messageId() {
      return this.message && this.message.id;
    },
    selectedMessageParams() {
      return {
        query: {
          $eager: "[member, action.[elaborator], files, notes]",
        },
      };
    },
    isSelected: {
      get() {
        return !!(this.message && this.message.id);
      },
      set(open) {
        this.isOpen = open;
      },
    },
  },
  methods: {
    trans() {
      if (!this.isOpen) this.close();
      else this.markRead();
    },
    close() {
      this.$emit("update:message", null);
    },
    async patchMessage(data) {
      if (this.readOnly) return;

      await this.selectedMessage.patch({
        data: data,
      });
    },
    markRead() {
      if (this.selectedMessage.read) return;
      this.patchMessage({ read: true });
    },
    toggleStarred() {
      this.patchMessage({ starred: !this.selectedMessage.starred });
    },
    toggleCompleted() {
      this.patchMessage({
        completed: !this.selectedMessage.completed,
        status: this.selectedMessage.completed ? null : "completed",
      });
    },
    toggleMapMarker() {
      let properties = this.selectedMessage && this.selectedMessage.properties;

      if (properties) {
        properties.show_map_marker =
          properties.show_map_marker !== undefined
            ? !properties.show_map_marker
            : true;
        this.patchMessage({ properties: properties });
      }
    },
    messageIcon(message) {
      let icon;
      let iconUrl;
      const action = message.action;
      const selectIconsScenes = action && action.elaborator.scenes.filter((scene) => scene.options && scene.options.icons && scene.options.useIconsOnMap);

      if ((!action || !action.properties || !action.properties.iconUrl) && !selectIconsScenes.length) return;

      if (selectIconsScenes && selectIconsScenes.length) {
        selectIconsScenes.forEach((iScene) => {
          const selectIcons = iScene.options && iScene.options.icons;

          if (!iconUrl) iconUrl = message.data && message.data[iScene.id] && selectIcons[message.data[iScene.id]]
        });
      }

      if (!iconUrl) iconUrl = action.properties && action.properties.iconUrl;
      icon = action.properties && action.properties.icon;

      return iconUrl || icon;
    },
    saveApproval() {
      this.patchMessage({ approved: this.selectedMessage.approved });
    },
    setStatus() {
      this.patchMessage({ status: this.selectedMessage.status });
    },
    remove() {
      this.selectedMessage.remove();
      this.$emit("update:removed", true);
      this.close();
    },
    asDate(timestamp) {
      return moment.unix(timestamp).format("YYYY/MM/DD HH:mm");
    },
  },
  watch: {
    isGetSelectedMessagePending(pending) {
      if (!pending && this.selectedMessage) {
        this.icon = this.messageIcon(this.selectedMessage);
      }
    }
  },
  props: {
    message: {
      type: Object,
      default: () => {
        return null;
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ImageMagnify,
    Notes,
    Data,
  },
};
</script>

<style lang="scss" scoped>
.message-toolbar {
  width: 100%;
}

.message-drawer {
  z-index: 1001;
}

.message-container {
  padding-top: 64px;

  .newlines {
    white-space: pre;
  }
  .elaborated-message {
    display: inline-block;
    width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: pre-wrap;
  }

  .image-grid-block {
    position: relative;
    cursor: pointer;

    .image-magnify {
      position: absolute;
      bottom: 0;
      right: 0;
      margin: 0 15px 15px 0;
      z-index: 10;
    }
  }

  .theme--dark.v-tabs-items {
    background-color: transparent;
  }
}
</style>